module.exports = __webpack_public_path__ + "static/media/fine.eaefdb9c.png";